<script>
    import {_} from '../lib/i18n';
    import {changeAutogeneratedEmail} from "../lib/ApiRequests.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";

    export let show = false;
    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let analyze;

    export let paidTill;

    function closeModal() {
        show = false;
    }

    let isLoading = false;
    let newEmail = '';
    let error = '';
    let errorCode;
    async function changeTemporaryEmail() {
        isLoading = true;
        error = '';
        const response = await changeAutogeneratedEmail(newEmail);
        if (response.status === 'ok') {
            params.setPasswordAsTemporary();
            params.changeTemporaryEmail(newEmail);
            window.shared.updateState();

            try {
                if (analyze) {
                    const result = await params.createAnalyze(analyze.account.username, 1, 0);
                }
            } catch (err) {
                console.error(err);
            }
            show = false;
        } else {
            try {
                errorCode = response.error_code;
                error = response.message;
            } catch (err) {
                console.error(err);
            }
        }
        isLoading = false;
    }


</script>

<section class={`modal ${show ? '' : 'hide'}`}>
    <div class="modal__fade"></div>
    <div class="modal-body modal-body_subscription-cancel">
        <div on:click={closeModal} class="modal-body__close-icon" on:click={closeModal}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.06665 7.4668L15.5333 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.5333 7.4668L8.06666 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <div class="modal-body__header modal-body__header">

            <h4 class="modal-body__header-title">
                {$_('changeTempEmailModal.title')}
            </h4>
        </div>

        <div class="modal-body__content-wrapper">
            <p class="modal-body__content-text mb-32px">{@html $_('changeTempEmailModal.description', { })}</p>

            <form on:submit|preventDefault={changeTemporaryEmail} class="account-settings__form">
                <div class="account-settings__form input-wrap mb-24px">
                    <input id="user-email" type="email" bind:value={newEmail}
                           class={`${error ? 'error' : ''} general-input account-settings__form-email-input-bak`}
                           placeholder={$_('changeTempEmailModal.inputPlaceholder')}
                    />

                    {#if error}
                        <p class="account-settings__form-error">{error}</p>
                    {/if}
                </div>


                <button type="submit" class="button button_shadow modal-body__btn-main" disabled={isLoading}>
                    <LoadingIcon show={isLoading} width="16" height="16"/>
                    {$_('changeTempEmailModal.submitBtnLabel')}
                </button>
            </form>
        </div>

    </div>
</section>

<style>
    .mb-24px {
        margin-bottom: 24px;
    }
    .mb-32px {
        margin-bottom: 32px;
    }
    .hide {
        display: none;
    }
    .modal-body__header-title {
        color: #57A41B;
    }
    .modal-body__header-icon {
        background-color: #F2D2C0;
    }

    section.modal {
        margin-left: 0;
        margin-right: 0;
    }
    .modal-body {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>